import request from '@/utils/request'

// 获取个人资料
export function getUserProfile() {
  return request({ url: '/ftx/user-center/profile', method: 'get' })
}

// 修改个人资料
export function updateProfile(data) {
  return request({ url: '/ftx/user-center/profile', method: 'put', data })
}

// 修改登录密码
export function changeLoginPwd(data) {
  return request({ url: '/ftx/user-center/password/login', method: 'put', data })
}

// 修改交易密码
export function changeTradePwd(data) {
  return request({ url: '/ftx/user-center/password/trade', method: 'put', data })
}

// 设置交易密码（首次）
export function setTradePwd(data) {
  return request({ url: '/ftx/user-center/password/trade/set', method: 'post', data })
}

// 获取KYC认证状态
export function getKycStatus(options = {}) {
  return request({ url: '/ftx/user-center/kyc/status', method: 'get', ...options })
}

// 提交基础KYC
export function submitBasicKyc(data) {
  return request({ url: '/ftx/user-center/kyc/basic', method: 'post', data })
}

// 提交高级KYC
export function submitAdvancedKyc(data) {
  return request({ url: '/ftx/user-center/kyc/advanced', method: 'post', data })
}
